import { render } from "./RobotEntry.vue?vue&type=template&id=2b37677e&scoped=true"
import script from "./RobotEntry.vue?vue&type=script&lang=js"
export * from "./RobotEntry.vue?vue&type=script&lang=js"

import "./RobotEntry.vue?vue&type=style&index=0&id=2b37677e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b37677e"]])

export default __exports__